import { render } from "./PersonaKeyword.vue?vue&type=template&id=43e5a20c&scoped=true"
import script from "./PersonaKeyword.vue?vue&type=script&lang=js"
export * from "./PersonaKeyword.vue?vue&type=script&lang=js"

import "./PersonaKeyword.vue?vue&type=style&index=0&id=43e5a20c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e5a20c"]])

export default __exports__